<template>
  <div
    class="flex flex-col p-4 w-full text-black rounded-xl transition-colors"
    :class="checked ? 'border-2 border-[#EC0F03]' : 'border border-[#5C5C5C47]'"
  >
    <div class="flex space-x-4 items-center">
      <div class="relative flex-shrink-0 mt-1">
        <input
          ref="radioInput"
          :id="inputId"
          type="radio"
          :name="name"
          :value="value"
          :checked="checked"
          :disabled="disabled"
          @change="$emit('change', $event)"
          class="sr-only"
        />
        <div
          @click="!disabled && $refs.radioInput?.click()"
          tabindex="0"
          role="radio"
          class="w-4 h-4 cursor-pointer rounded-full border transition-all duration-200"
          :class="[
            checked ? 'border-[#EC0F03] bg-[#EC0F03] ' : 'border-[#161616A6] ',
            disabled && 'opacity-50 cursor-not-allowed',
          ]"
        >
          <div
            class="w-full h-full rounded-full transition-transform duration-200 origin-center"
            :class="checked ? 'scale-30 bg-white' : 'scale-0'"
          />
        </div>
      </div>

      <label
        :for="inputId"
        class="w-full transition-colors"
        :class="disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'"
      >
        <div class="flex justify-between w-full">
          <div class="flex justify-between items-center w-full min-h-[2rem]">
            <div class="flex-1">
              <slot name="content" />
            </div>
            <div class="flex-shrink-0 ml-4">
              <slot name="aside" />
            </div>
          </div>
        </div>
      </label>
    </div>

    <div v-if="checked" class="overflow-hidden">
      <slot name="expanded" />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  id: string
  checked: boolean
  name: string
  value: string | number
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  checked: false,
})

defineEmits<{
  change: [event: Event]
}>()

const inputId = computed(() => props.id || `radio-${props.name}-${props.value}`)
</script>
